export default () => {
  const wrappers = document.querySelectorAll('[data-360]');

  const init = (el) => {
    const images = [...el.children];
    const total = images.length - 1;
    let frame = 0;
    const threshold = 10;
    const impetus = new Impetus({
      source: el,
      update(x) {
        images[frame].classList.remove('active');
        frame = Math.floor(-x / threshold) % total;
        frame = frame <= 0 ? total + frame : frame;
        images[frame].classList.add('active');
      },
    });
    images[frame].classList.add('active');
  
    // cursor
    el.addEventListener('mousedown', () => (el.style.cursor = 'grabbing'));
    el.addEventListener('mouseup', () => (el.style.cursor = 'grab'));
  };
  
  wrappers.forEach((el) => init(el));  
}